export default "__VITE_ASSET__37277e1d__"